import { render, staticRenderFns } from "./DispensaryManagerBasic.vue?vue&type=template&id=014a770e&scoped=true&"
import script from "./DispensaryManagerBasic.vue?vue&type=script&lang=js&"
export * from "./DispensaryManagerBasic.vue?vue&type=script&lang=js&"
import style0 from "./DispensaryManagerBasic.vue?vue&type=style&index=0&id=014a770e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a770e",
  null
  
)

export default component.exports